import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../common/spinner";
import * as service from "./bundledOrderListServices";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { log } from "../../helper/helper";
import {
    Button,
    Row,
    Col,
    Space,
    Input,
} from "antd";
function BundleOrderSearch(props) {
    const [isLoading, setLoading] = useState(false);
    const [bundleId, setBundleId] = useState("");
    const [bundleIdStatusError, setBundleIdStatusError] = useState("");


    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (!user) {
                return props.history.replace("/login");
            }
        });

    }, []);

    const renderSpinner = () => (isLoading ? <Spinner /> : null);

    const adminFindBundledTransports = async (value) => {
        setBundleIdStatusError("");
        if (bundleId.length < 1) {
            return setBundleIdStatusError("error");
        }

        setLoading(true);
        try {
            const result = await service.adminFindBundledTransports(Number(bundleId));
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        props.history.push("/home/bundledOrderSingle", {
                            orderDetail: result.data
                        });
                        return;
                    case 401:
                        toast.error(result.data.message);
                        return props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            log(error);
            toast.error(error.message);
        }
        setLoading(false);
    };

    return (
        <div>
            <ToastContainer />
            {renderSpinner()}
            <h2 style={{ marginTop: 50 }} >Find Bundle</h2>
            <div className="container"
                style={{
                    height: "50vh",
                    display: "flex",
                    justifyContent: "center",   // horizontal center
                    alignItems: "center"         // vertical center
                }}>
                <Row gutter={[16, 16]} align="middle" justify="center" style={{ marginBottom: 10 }}>
                    <Col span={24}>
                        <Input
                            status={bundleIdStatusError}
                            placeholder="Order Number"
                            size="large"
                            value={bundleId}
                            onChange={(e) => setBundleId(e.target.value)}
                            style={{ margin: "20px 0" }}
                        />
                    </Col>
                    <Col span={24}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => adminFindBundledTransports()}
                            block
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
}


export default BundleOrderSearch;
